var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "contents-inner" },
    [
      _c(
        "job-preview-content-data-outline-sp",
        {
          staticClass: "mb15",
          attrs: { "update-date": _vm.environment.updateDate },
        },
        [
          _c(
            "div",
            { staticClass: "data-area pt20" },
            [
              _c("job-preview-content-pie-data-sp", {
                staticClass: "mb10",
                attrs: {
                  title: "女性社員の割合",
                  value: _vm.environment.womanRate,
                },
              }),
              _vm._v(" "),
              _c("job-preview-content-bar-data-sp", {
                staticClass: "mb10",
                attrs: {
                  title: "有給取得率",
                  value: _vm.environment.ptoRate,
                  "average-value": _vm.average.environment.pto,
                  unit: "%",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("p", { staticClass: "tc" }, [
            _vm._v("\n      " + _vm._s(_vm.companyName) + "\n    "),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "tc" }, [
            _vm._v("\n      の働く環境についてもっと知りたい方はこちら\n    "),
          ]),
          _vm._v(" "),
          _c("job-preview-button", { attrs: { title: "データをすべて見る" } }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }